import type { User } from '@/contexts/AuthContext';

/** OAuth profile image when the user signed in with Google (or similar). */
export function getUserProfileImageUrl(user: Pick<User, 'json_data' | 'picture'>): string {
    if (user.json_data?.google_login) {
        return user.picture ?? '';
    }
    return '';
}
